import { callGTMEvent } from './datalayer';
$(document).ready(function() {

    //fn currency format
    function currencyFormat(num) {
        var parts = num.toFixed(2).split(".");
        return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
            (parts[1] ? "." + parts[1] : "");
    }

    //Next Prev & Calculate
    function scrollTop() {
        $("html, body").animate({ scrollTop: 300 }, 1000);
    }

    function getCurrentStep() {
        var active_class = $('.content-active').attr('class');
        if (active_class.includes('step_one')) return 1;
        else if (active_class.includes('step_two')) return 2;
        else if (active_class.includes('step_three')) return 3;
        else return 0;
    }

    $(".btn-next").on("click", function(event) {
        $("#validate-form")
            .parsley()
            .validate("deduction");
        if (
            $("#validate-form")
            .parsley()
            .isValid("deduction")
        ) {
            event.preventDefault();
            var curStep = getCurrentStep();
            if (curStep == 2) prepGTMEvent('calculate', curStep);
            else prepGTMEvent('nextStep', curStep);
            $('.content-active').removeClass('content-active')
                .hide()
                .next()
                .show()
                .addClass('content-active');
            $('.nav-active').removeClass('nav-active')
                .removeClass('nav-active')
                .next()
                .addClass('nav-active')
                .addClass('nav-active');
            $(".nav-active").prev().addClass('nav-previous');
            scrollTop()
        }
    });

    $('.btn-previous').on('click', function(event) {
        prepGTMEvent('prevStep', getCurrentStep());
        $('.content-active').removeClass('content-active')
            .hide()
            .prev()
            .show()
            .addClass('content-active');

        $('.nav-active').removeClass('nav-active')
            .removeClass('.nav-active')
            .prev()
            .addClass('.nav-active')
            .addClass('nav-active');
        $(".nav-active").removeClass('nav-previous');

        scrollTop()
    });

    $('.btn-results').on('click', function(event) {
        event.preventDefault();
        prepGTMEvent('calculateAgain', getCurrentStep());
        // $('.form-slider--single').css("margin-left", "-33%");
        $('.content-active').removeClass('content-active')
            .hide()
            .prev()
            .prev()
            .show()
            .addClass('content-active');

        $('.nav-active').removeClass('nav-active');
        $(".nav-previous").removeClass('nav-previous');
        $(".step1").addClass('nav-active');

        scrollTop()
    });

    // Calculator

    // Page 1 Has Child
    $("#toggleSwitch").on('click', function() {
        $(".toggle").toggleClass('toggle-checked');
        $("#sectionToggle").slideToggle();
    });

    // Calculator state selector
    $('.state-selector .state-selector--tab').on('click', function() {
        $('.state-selector--tab').removeClass('state-active ');
        $(this).addClass('state-active');
    })

    // Calculator : Income

    $('#grossincome, #freelanceincome, #otherincome').keyup(function() {

        var grossIncome = parseFloat($('#grossincome').val()) || 0;
        $('#grossincome_output').text(currencyFormat(grossIncome));

        var freelanceIncome = parseFloat($('#freelanceincome').val()) || 0;
        $('#freelanceincome_output').text(currencyFormat(freelanceIncome));

        var otherIncome = parseFloat($('#otherincome').val()) || 0;
        $('#otherincome_output').text(currencyFormat(otherIncome));

        var totalIncome = grossIncome + freelanceIncome + otherIncome;

        $('#totalincome').text('RM ' + currencyFormat(totalIncome));

    });

    // Calculator : Deduction
    function totalDeduction() {
        var totalWives = ($('#wives').val()) * ($wives);
        var totalEpf = ($('#grossincome').val()) * ($epf);
        if ($total_child == undefined) {
            $total_child = 0;
        }
        var totalDeduction = parseInt(totalWives) + parseFloat(totalEpf) + parseInt(per_expenses) + $total_child;
        $('#totaldeduction').text('RM ' + currencyFormat(totalDeduction));
    }

    // Deduction => Personal Expenses & State toggle
    var per_expenses = 11300;
    var state_selector = "selangor";

    var personalExpenses = $("div").filter(".personal-expense");
    var visible_personalExpenses;

    $('input[type=radio][name=region]').on('click', function() {

        personalExpenses.show();
        var selected_state = $(this).val();
        visible_personalExpenses = personalExpenses.filter(region(selected_state));
        personalExpenses.not(visible_personalExpenses).hide();
        if ($('input[name="region"]:checked').val() == "federal") {
            per_expenses = 12000;
            $('#totaldeduction').text('RM ' + currencyFormat(per_expenses));
            $("#child3, #child4, #child5").attr('disabled', 'true');
            state_selector = "federal";
        } else {
            per_expenses = 11300;
            $("#child3, #child4, #child5").removeAttr("disabled");
            state_selector = "selangor";
        }

        $('#totaldeduction').text('RM ' + currencyFormat(per_expenses));

        $("#child1_output, #child2_output, #child3_output, #child4_output, #child5_output").text("RM 0");

        $("#child1, #child2, #child3, #child4, #child5").val();
    });

    function region(category) {
        switch (category) {
            case 'selangor':
                return personalExpenses.filter(function() {
                    return $(this).data("category") == "selangor";
                });
            case 'federal':
                return personalExpenses.filter(function() {
                    return $(this).data("category") == "federal";
                });
        }
    }

    // Deduction => Child
    var $total_child;

    function child() {
        var $child1 = 6850;
        var $child2 = 2350;
        var $child3 = 1450;
        var $child4 = 2400;
        var $child5 = 2400;

        if ($('input[name="region"]:checked').val() == "federal") {
            $child1 = 5000;
            $child2 = 2000;
            $child3 = 0;
            $child4 = 0;
            $child5 = 0;

        } else {
            $child1 = 6850;
            $child2 = 2350;
        }
        var $child1_selangor = parseFloat($('#child1').val() * $child1);
        $('#child1_output').text('RM ' + currencyFormat($child1_selangor));

        var $child2_selangor = parseFloat($('#child2').val() * $child2);
        $('#child2_output').text('RM ' + currencyFormat($child2_selangor));

        var $child3_selangor = parseFloat($('#child3').val() * $child3);
        $('#child3_output').text('RM ' + currencyFormat($child3_selangor));

        var $child4_selangor = parseFloat($('#child4').val() * $child4);
        $('#child4_output').text('RM ' + currencyFormat($child4_selangor));

        var $child5_selangor = parseFloat($('#child5').val() * $child5);
        $('#child5_output').text('RM ' + currencyFormat($child5_selangor));

        $total_child = $child1_selangor + $child2_selangor + $child3_selangor + $child4_selangor + $child5_selangor;
    }

    // EPF & Wives
    var $wives = 5000;
    var $epf = 0.11;
    totalDeduction();

    $('#wives, #grossincome, #child1, #child2, #child3, #child4, #child5').keyup(function() {
        var totalWives = ($('#wives').val()) * ($wives);
        $('#wives_output').text(currencyFormat(totalWives));

        var totalEpf = ($('#grossincome').val()) * ($epf);
        $('#deduction_epf_output').text(currencyFormat(totalEpf));

        child();
        totalDeduction();
    })

    // Calculator : PAGE 2
    // Calculator : Gold silver
    $('#gold_bars, #gold_investments, #gold_jewellery, #gold_jewellery_uruf').keyup(function() {

        var goldBars = parseFloat($('#gold_bars').val()) || 0;
        $('#gold_bars_output').text(currencyFormat(goldBars));

        var goldInvestments = parseFloat($('#gold_investments').val()) || 0;
        $('#gold_investments_output').text(currencyFormat(goldInvestments));

        var goldJewellery = parseFloat($('#gold_jewellery').val()) || 0;
        $('#gold_jewellery_output').text(currencyFormat(goldJewellery));

        var goldJewelleryUruf = parseFloat($('#gold_jewellery_uruf').val()) || 0;
        $('#gold_jewellery_uruf_output').text(currencyFormat(goldJewelleryUruf));

        var totalGoldSilver = goldBars + goldInvestments + goldJewellery + goldJewelleryUruf;

        $('#total_gold').text('RM ' + currencyFormat(totalGoldSilver));
    });

    // Calculator : Savings
    $('#saving_account, #saving_fixed_deposit, #saving_insurance, #saving_epf, #saving_other').keyup(function() {

        var savingAccount = parseFloat($('#saving_account').val()) || 0;
        $('#saving_account_output').text(currencyFormat(savingAccount));

        var savingFixedDeposit = parseFloat($('#saving_fixed_deposit').val()) || 0;
        $('#saving_fixed_deposit_output').text(currencyFormat(savingFixedDeposit));

        var savingInsurance = parseFloat($('#saving_insurance').val()) || 0;
        $('#saving_insurance_output').text(currencyFormat(savingInsurance));

        var savingEpf = parseFloat($('#saving_epf').val()) || 0;
        $('#saving_epf_output').text(currencyFormat(savingEpf));

        var savingOther = parseFloat($('#saving_other').val()) || 0;
        $('#saving_other_output').text(currencyFormat(savingOther));

        var totalSavings = savingAccount + savingFixedDeposit + savingInsurance + savingEpf + savingOther;

        $('#totalsaving').text('RM ' + currencyFormat(totalSavings));
    });

    // Calculator : Investment
    $('#invest_shares, #invest_unit_trust, #invest_etf, #invest_reit, #invest_other').keyup(function() {

        var investmentShares = parseFloat($('#invest_shares').val()) || 0;
        $('#invest_shares_output').text(currencyFormat(investmentShares));

        var investmentUnitTrust = parseFloat($('#invest_unit_trust').val()) || 0;
        $('#invest_unit_trust_output').text(currencyFormat(investmentUnitTrust));

        var investmentEtf = parseFloat($('#invest_etf').val()) || 0;
        $('#invest_etf_output').text(currencyFormat(investmentEtf));

        var investmentReit = parseFloat($('#invest_reit').val()) || 0;
        $('#invest_reit_output').text(currencyFormat(investmentReit));

        var investmentOther = parseFloat($('#invest_other').val()) || 0;
        $('#invest_other_output').text(currencyFormat(investmentOther));

        var totalInvestment = investmentShares + investmentUnitTrust + investmentEtf + investmentReit + investmentOther;

        $('#totalInvestment').text('RM ' + currencyFormat(totalInvestment));
    });

    // Results
    $('#3').on('click', function() {
        //Income Zakat Owed
        var results_income = parseFloat((($('#totalincome').text()).slice(3, )).replaceAll(',', '')); //to remove ","
        console.log(results_income);
        var results_deduction = parseFloat((($('#totaldeduction').text()).slice(3, )).replaceAll(',', '')); //to remove ","

        $('#total_income_output').text("RM " + currencyFormat(results_income));
        $('#total_deduction_output').text("RM " + currencyFormat(results_deduction));

        var results_zakatable_income_view = results_income - results_deduction;
        var zakatable_income_view = 0;

        $('#zakatable_income_output').text("RM " + currencyFormat(results_zakatable_income_view))

        if (state_selector == "selangor") {
            // selanger
            if (results_zakatable_income_view >= 13490) {
                zakatable_income_view = results_zakatable_income_view * 0.025;
                $('#full_income').text("RM " + currencyFormat(zakatable_income_view));
            } else {
                $('#full_income').text("RM 0*");
            }

        } else {
            // federal
            if (results_zakatable_income_view >= 13968) {
                zakatable_income_view = results_zakatable_income_view * 0.025;
                $('#full_income').text("RM " + currencyFormat(zakatable_income_view));
            } else {
                $('#full_income').text("RM 0*");
            }
        }

        // Other Zakat Owed
        var results_gold = parseFloat((($('#total_gold').text()).slice(3, )).replaceAll(',', '')); //to remove ","
        var results_saving = parseFloat((($('#totalsaving').text()).slice(3, )).replaceAll(',', '')); //to remove ","
        var results_investment = parseFloat((($('#totalInvestment').text()).slice(3, )).replaceAll(',', '')); //to remove ","
        var zakatable_property_output = 0;

        $('#results_gold_output').text("RM " + currencyFormat(results_gold));
        $('#results_savings_output').text("RM " + currencyFormat(results_saving));
        $('#results_investments_output').text("RM " + currencyFormat(results_investment));

        var results_zakatable_property_output = results_gold + results_saving + results_investment;

        $('#results_zakatable_property_output').text("RM " + currencyFormat(results_zakatable_property_output))

        if (state_selector == "selangor") {
            // selangor
            if (results_zakatable_property_output >= 13490) {
                zakatable_property_output = results_zakatable_property_output * 0.025;
                $('#other_zakatable_income_output').text("RM " + currencyFormat(zakatable_property_output));
            } else {
                $('#other_zakatable_income_output').text("RM 0*");
            }
        } else {
            // federal
            if (results_zakatable_property_output >= 13968) {
                zakatable_property_output = results_zakatable_property_output * 0.025;
                $('#other_zakatable_income_output').text("RM " + currencyFormat(zakatable_property_output));
            } else {
                $('#other_zakatable_income_output').text("RM 0*");
            }
        }
        $('#main_total').text("RM " + currencyFormat(zakatable_income_view + zakatable_property_output));
    });
});

$(window).on('load', function() {
    prepGTMEvent('formLoaded', 1);
});

// Added for datalayer for Moengage
const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "Tablet";
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
        )
    ) {
        return "Mobile";
    }
    return "Desktop";
};

function prepGTMEvent(eventname, step, email = '') {
    var dataLayerTemp = {
        event: eventname,
        step_form: step,
        product_category: 'Tools',
        product_name: 'Zakat Calculator'
    };
    if (email) dataLayerTemp['email'] = email;
    
    return callGTMEvent(eventname, dataLayerTemp);
}